import angular from 'angular';
import constants from 'app/constants';

import {
  praDataService,
  ssDialogService,
  userService,
} from 'app/services';

import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import addPraAssessmentDialog from '../dialog.addAssessmentDialog';
import praBoardApproveDialog from '../dialog.boardApproveDialog';
import generatePRAReportDialog from './dialog.generatePRAReportDialog';
import bulkSubmitProcessesDialog from './dialog.bulkSubmitProcessesDialog';
import bulkApproveProcessesDialog from './dialog.bulkApproveProcessesDialog';
import bulkResetProcessesDialog from './dialog.bulkResetProcessesDialog';
import controller from './incomplete-assessment.controller';
import directive from './incomplete-assessment.directive';
import praProcesses from './processes';


export default angular.module('app.components.advisory.pra.incompleteAssessment', [
  addPraAssessmentDialog,
  alerts,
  praDataService,
  praBoardApproveDialog,
  confirmDialog,
  constants,
  praProcesses,
  ssDialogService,
  userService,
  generatePRAReportDialog,
  bulkSubmitProcessesDialog,
  bulkApproveProcessesDialog,
  bulkResetProcessesDialog
])
  .directive('praIncompleteAssessment', directive)
  .controller('PRAIncompleteAssessmentController', controller)
  .name;

console.log('app.components.advisory.pra.incompleteAssessment created');
